export default {
	editusertitle(){
		if(!this.edituser && (!this.edituser.fancyname && !this.edituser.title)) {
			if(this.id == 'new'){
				return this.$t('Create new {name}', { name: (this.role ? this.role : 'User') });
			} else {
				return false;
			}
		}
		if(this.id == 'new'){
			return this.$t('Create new {name}', { name: (this.edituser.fancyname ? this.edituser.fancyname : this.edituser.title) });
		}

		return this.$t('Edit {name}', { name: (this.edituser.fancyname ? this.edituser.fancyname : this.edituser.title) });
	},
	hasfitlers(){
		if(this.filters.roles && this.filters.roles.length > 0){
			return true;
		}
		if(this.filters.my || this.filters.progress_status){
			return true;
		}

		if(this.filters.q && this.filters.q.length > 0){
			return true;
		}
	},
	iscurrentrole(role){
		if(!this.role) {
			console.log('iscurrentrole', this.role);
			return false;
		}
		return role.name == this.role.name;
	},

	iscurrentsubrole(role){
		if(!this.role) {
			console.log('iscurrentsubrole', this.role);
			return false;
		}
		return this.role.subroles.find(function(obj){
            return obj.name === role.name;
        });
	},

	issubrole(role){
		if(!this.channel) {
			console.log('issubrole', this.channel);
			return false;
		}
		return this.channel.subroles.find(function(obj){
            return obj.name === role.name;
        });
	},

	isleaderrole(role){
		return role.name.match(/_leader/);
	},

	getroleusers(role, leaders){
		if(!leaders) return [];
		return leaders.filter(function(user){
			if(!user.mainrole) return false;
            return user.mainrole.name === role.name;
        });
	}
};



// WEBPACK FOOTER //
// ./src/helpers/user.js